import { Box, Typography } from '@mui/material';
import CustomModal from 'src/components/modal/customModal';
import { renderErrorMessage, renderSuccessMessage } from 'src/lib/toastMessage';;
import { styled, useTheme } from '@mui/material/styles';
import { axiosPostCall } from 'src/services/apisCall';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const InputContainer = styled('div')(() => ({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    gap: '20px',
}));
const FieldHeading = styled(Typography)(() => ({
    fontWeight: 500,
}));


const AddElasticServer = ({ openModal, forceLoad, loadit, handleCloseModal, title, edit, data }) => {
    const theme = useTheme();

    const Schema = Yup.object().shape({
        host: Yup.string().required('Host is required'),
        port: Yup.string().required('Port is required'),
        username: Yup.string().required('Username is required'),
        password: Yup.string().required('Password is required'),
        protocol: Yup.string().required('Protocol is required'),

    });

    const methods = useForm({
        resolver: yupResolver(Schema),
        defaultValues: {
            host: '',
            port: '',
            username: '',
            password: '',
            protocol: '',
        },
    });

    const { control, watch, setValue, handleSubmit, reset, formState: { errors } } = methods;
    const onSubmit = async (data) => {
        try {
            const payload = {
                esHost: data.host,
                esPort: data.port,
                esUserName: data.username,
                esPassword: data.password,
                esProtocol: data.protocol,

            };
            console.log(payload);
             await axiosPostCall('getAddEsBackupServer', payload);
            renderSuccessMessage('Elastic Server added successfully');
            handleCloseModal();
            reset();
            forceLoad(true);
        } catch (error) {
            if (error.response) {
                renderErrorMessage(error.response.data.message);
            }
        }
    }


    const description = (
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Box
                component="form"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: '20px',
                    width: '400px',
                    padding: '25px'
                }}
                noValidate
                autoComplete="off"
            >
                <InputContainer>
                    <RHFTextField type="text" size="large" name="protocol" label="Protocol" placeholder="Protocol" />
                </InputContainer>
                <InputContainer>
                    <RHFTextField type="text" size="large" name="host" label="Host" placeholder="Host" />
                </InputContainer>
                <InputContainer>
                    <RHFTextField type="text" size="large" name="port" label="Port" placeholder="Port" />
                </InputContainer>
                <InputContainer>
                    <RHFTextField type="text" size="large" name="username" label="User Name" placeholder="User Name" />
                </InputContainer>
                <InputContainer>
                    <RHFTextField type="text" size="large" name="password" label="Password" placeholder="Password" />
                </InputContainer>
                <Box
                    sx={{
                        width: '7.625rem',
                        backgroundColor: '#212B36',
                        borderRadius: '8px',
                        p: '0.562rem',
                        height: '2.375rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        pointerEvents: 'auto',
                    }}
                    onClick={handleSubmit(onSubmit)}
                >
                    <Typography sx={{ fontWeight: 600, color: '#fff' }}>
                        Submit
                    </Typography>
                </Box>
            </Box>
        </FormProvider>
    );

    return openModal && (
        <CustomModal
            open={openModal}
            title={title}
            description={description}
            close={handleCloseModal}
            isCloseIcon={true}
        />
    );
};
export default AddElasticServer;